module.exports = __webpack_public_path__ + "img/forgot-password-v2.33821d5d.svg";